// src/components/PaywallGuard.jsx
import { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import curriculum from '../data/curriculum';
import PaywallModal from './PaywallModal';

// Lessons unlocked when coming from blog
// Add new lesson IDs here when you add new blog posts
const BLOG_FREE_LESSONS = {
  '03-03': true, // Single candle patterns — hammer blog
  '06-03': true, // RSI — RSI blog post
  '04-02': true, // Support & Resistance — S&R blog post
  '07-04': true, // Risk to Reward — RR blog post
};

export default function PaywallGuard({ children }) {
  const { moduleId, lessonId } = useParams();
  const { search } = useLocation();
  const { user, isPaid, loading } = useAuth();
  const [showModal, setShowModal] = useState(true);

  // DEV MODE — all lessons unlocked on localhost
  if (process.env.NODE_ENV === 'development') return children;

  const fromBlog  = new URLSearchParams(search).get('ref') === 'blog';
  const lessonKey = `${moduleId}-${lessonId}`;
  const lesson    = curriculum[moduleId]?.lessons[lessonId];

  if (loading) return null;
  if (!lesson) return children;
  if (lesson.free) return children;
  if (isPaid) return children;

  // Blog referral — only unlock the specific lesson linked from blog
  if (fromBlog && BLOG_FREE_LESSONS[lessonKey]) return children;

  if (showModal) {
    return (
      <>
        {children}
        <PaywallModal onClose={() => setShowModal(false)} />
      </>
    );
  }

  return children;
}